import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { AppService } from '../../store/app.service';
import { CouponsApiService } from './coupon.apiservice';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CouponsService {

    constructor(
        private appService: AppService,
        private couponService: CouponsApiService,
        private router: Router,
        private translate: TranslateService
    ) { }

    deleteCoupon() {
        var d = this.appService.getActiveRoute$().value.url.split('/');
        var cId = d[d.length - 1];
        Swal.fire({
            title: this.translate.instant('ARE_YOU_SURE'),
            text: this.translate.instant('CANNOT_REVERT_ACTION'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.translate.instant('YES_DELETE_IT')
        }).then((result) => {
            if (result.isConfirmed) {
                this.couponService.deleteCoupon([cId])
                    .subscribe((r: any) => {
                        if (r.good) {
                            this.router.navigate(['/pages/coupons']);
                        }
                    })
            }
        })
    }

}
